module.exports = __webpack_public_path__ + "static/media/nav-scanline-right.60ad5b7f.svg";